import { Link } from 'react-router-dom';
import { useAuth } from '../state/auth';
import { SelecteurLangue } from '../components/SelecteurLangue';
import { T } from '../i18n';
import { menuPour } from '../components/menu';

/**
 * Le menu complet sur téléphone.
 *
 * Sans cet écran, treize des dix-sept écrans étaient tout simplement
 * inatteignables depuis un telephone : la barre latérale est masquée en dessous
 * de 900 px et la barre d'onglets n'en montrait que cinq.
 */
export default function Plus() {
  const { user, peut, estAgent, deconnexion } = useAuth();
  const groupes = menuPour(peut, estAgent);

  return (
    <>
      <div className="entete">
        <div className="titres">
          <h1>{T.plus.titre}</h1>
          <p>{user?.nom} · {user?.roleLibelle}</p>
        </div>
      </div>

      <div style={{ display: 'grid', gap: 20 }}>
        {groupes.map((g) => (
          <section key={g.titre}>
            <div className="micro" style={{ marginBottom: 8 }}>{g.titre}</div>
            <div style={{ display: 'grid', gap: 8 }}>
              {g.entrees.map((e) => (
                <Link key={e.to} to={e.to} className="carte carte-p"
                      style={{ display: 'flex', alignItems: 'center', gap: 14, color: 'inherit',
                               textDecoration: 'none', minHeight: 56, padding: '12px 16px' }}>
                  <span style={{ fontSize: 20, width: 26, textAlign: 'center' }} aria-hidden="true">{e.icone}</span>
                  <span style={{ flex: 1, fontWeight: 600, fontSize: 16 }}>{e.label}</span>
                  <span className="sourdine" aria-hidden="true">›</span>
                </Link>
              ))}
            </div>
          </section>
        ))}
      </div>

      <div style={{ marginTop: 24 }}>
        <SelecteurLangue />
      </div>

      <button className="btn btn-bloc btn-l" style={{ marginTop: 16 }} onClick={deconnexion}>
        {T.plus.seDeconnecter}
      </button>
    </>
  );
}
